<template>
  <div class="menu-actions">
    <v-row
      no-gutters
      class="menu-actions-row"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        :class="[
          'menu-action-col',
          {'menu-action-col--collapsed': collapsed}
        ]"
      >
        <div class="button-wrapper">
          <button
            ref="newChatButton"
            type="button"
            :class="[
              'menu-button',
              {'menu-button--collapsed': collapsed}
            ]"
            :disabled="newChatDisabled"
            @mouseenter="showTooltip('new-chat')"
            @mouseleave="hideTooltip"
            @click="onButtonClick('new-chat')"
          >
            <v-icon
              class="menu-icon"
              size="22"
            >
              mdi-square-edit-outline
            </v-icon>

            <span
              v-if="!collapsed"
              class="menu-label"
            >
              New Chat
            </span>
          </button>
        </div>
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="12"
        :class="[
          'menu-action-col',
          {'menu-action-col--collapsed': collapsed}
        ]"
      >
        <div class="button-wrapper">
          <button
            ref="pastActivityButton"
            type="button"
            :class="[
              'menu-button',
              {'menu-button--collapsed': collapsed}
            ]"
            :disabled="pastActivityDisabled"
            @mouseenter="showTooltip('past-activity')"
            @mouseleave="hideTooltip"
            @click="onButtonClick('past-activity')"
          >
            <v-icon
              class="menu-icon"
              size="22"
            >
              mdi-history
            </v-icon>

            <span
              v-if="!collapsed"
              class="menu-label"
            >
              Past Activity
            </span>
          </button>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'MenuActions',

  props: {
    collapsed: {
      type   : Boolean,
      default: false
    },
    newChatDisabled: {
      type   : Boolean,
      default: false
    },
    pastActivityDisabled: {
      type   : Boolean,
      default: false
    }
  },

  data () {
    return {
      tooltipElement: null
    }
  },

  watch: {
    collapsed (newVal) {
      if (newVal) {
        this.removeTooltip()
      }
    }
  },

  beforeDestroy () {
    this.removeTooltip()
  },

  methods: {
    showTooltip (type) {
      if (!this.collapsed) {
        return
      }

      const buttonRef = type === 'new-chat' ? 'newChatButton' : 'pastActivityButton'
      const button = this.$refs[buttonRef]
      const text = type === 'new-chat' ? 'New Chat' : 'Past Activity'

      if (!button) return

      this.removeTooltip()

      const tooltip = document.createElement('div')
      tooltip.className = 'menu-actions-tooltip'
      tooltip.textContent = text

      const rect = button.getBoundingClientRect()

      tooltip.style.cssText = `
        position: fixed;
        left: ${rect.left + rect.width / 2 + 20}px;
        top: ${rect.top + rect.height / 2}px;
        transform: translate(0, -50%);
        padding: 3px 8px;
        background: rgba(255, 255, 255, 0.95);
        color: #041f30;
        font-family: 'Inter';
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        white-space: nowrap;
        z-index: 1000;
        pointer-events: none;
        opacity: 0;
        animation: tooltipFadeInRight 0.15s ease forwards;
      `

      document.body.appendChild(tooltip)
      this.tooltipElement = tooltip
    },

    hideTooltip () {
      this.removeTooltip()
    },

    onButtonClick (type) {
      this.removeTooltip()
      this.$emit(type === 'new-chat' ? 'new-chat' : 'past-activity')
    },

    removeTooltip () {
      if (this.tooltipElement) {
        this.tooltipElement.remove()
        this.tooltipElement = null
      }
    }
  }
}
</script>

<style scoped>
.menu-actions {
  flex: 0 0 auto;
  width: 100%;
}

.menu-actions-row {
  margin: 0;
  gap: 2px;
}

.menu-action-col {
  display: flex;
  padding: 0;
}

.menu-action-col--collapsed {
  justify-content: center;
  padding: 0;
}

.button-wrapper {
  position: relative;
  display: flex;
  width: 100%;
}

.menu-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding-left: 16px;
  padding-right: 16px;

  width: 100%;
  max-width: 100%;
  height: 38px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #041f30;

  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
  line-height: 16px;

  transition: background-color .15s ease;
  position: relative;
  isolation: isolate;
}

.menu-button::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 8px;
  right: 8px;
  border-radius: 8px;
  background: #ffffff;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.15s ease;
}

.menu-button:hover:not(:disabled)::before {
  opacity: 1;
}

.menu-button:disabled {
  opacity: 0.5;
}

.menu-button--collapsed {
  justify-content: center;
  padding: 0;
}

.menu-button--collapsed::before {
  top: 4px;
  bottom: 4px;
  left: 16px;
  right: 16px;
}

.menu-button--collapsed .menu-icon {
  justify-content: center;
  margin: 0;
  padding: 0;
}

.menu-icon {
  opacity: 0.9;
  flex: 0 0 auto;
  color: #041f30;
  padding-right: 8px;
}

.menu-label {
  white-space: nowrap;
}
</style>

<style>
@keyframes tooltipFadeInRight {
  from {
    opacity: 0;
    transform: translate(0, -50%) translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translate(0, -50%) translateX(0);
  }
}
</style>
